import { computed, ref, watch } from "vue"
import model from "../model";

const playUrl = ref<string>();

export default {
    init(){
        model.on('LogoutComplete', () => {
            playUrl.value = undefined;
        });

        watch(() => model.rtbeState, () => {
            const instance = Object.values(model.rtbeState?.public.bonusInstances || {}).find(x => {
                const data = x.minigame?.minigameData;
                if(!data) return false;
                return data.playUrl && data.playStatus == 'READY';
            });

            const url = instance?.minigame?.minigameData.playUrl;
            if(url) playUrl.value = url;
        }, {flush: 'sync'});
    },
}

export const rtbePlayMiniGameUrl = computed<string | undefined>(() => {
    return playUrl.value;
});

export function closeRtbeMiniGame(){
    playUrl.value = undefined;
}